import React from 'react';
import RoutedTabs from 'src/components/routed-tabs';
import {Switch, Route, Redirect} from 'react-router-dom';
import SuperAdmins from 'src/views/admin/SuperAdmins';
import CollegePortalUsers from 'src/views/admin/CollegePortalUsers';

const InternalCollegePortalUsers = () => <CollegePortalUsers queryOptions={{impostor: 'true'}} />;

const InternalUsers = () => (
  <div>
    <RoutedTabs
      tabs={[
        {label: 'Super Admins', path: '/super-admins'},
        {label: 'Internal College Portal Users', path: '/college-portal'},
      ]}
    />
    <Switch>
      <Route path="/admin/tools/internal-users/super-admins" component={SuperAdmins} />
      <Route
        path="/admin/tools/internal-users/college-portal"
        component={InternalCollegePortalUsers}
      />
      <Redirect path="*" to="/admin/tools/internal-users/super-admins" />
    </Switch>
  </div>
);

export default InternalUsers;
